exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh1.page-title[data-v-85ff7eea] {\n  color: #fff;\n  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);\n  font-size: 2em;\n  font-weight: 400;\n  margin-bottom: 15px;\n}\nh3.page-title[data-v-85ff7eea] {\n  color: #fff;\n  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);\n}\n.block[data-v-85ff7eea] {\n  background: #fff;\n}\n.btn--default[data-v-85ff7eea] {\n  margin: 20px auto 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-85ff7eea","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"includePaths":["/Users/noomz/Projects/Opendream/kadnud/kadnud-eef-app/src/css"],"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/templates/products/donate.vue
// module id = 598
// module chunks = 1